import type { ReactNode } from 'react';

import type { Maybe } from '@/lib/types';

import * as S from './ProductLabel.styles';

export interface ProductLabelProps {
  text: Maybe<ReactNode>;
}

export const ProductLabel = ({ text }: ProductLabelProps) => {
  return <S.Wrapper data-test-id='ProductLabelWrapper'>{text}</S.Wrapper>;
};

ProductLabel.displayName = 'ProductLabel';
